function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 78,
  height: 4,
  y: 36,
  fill: "#E3E9F0",
  opacity: 0.6,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 65.139,
  height: 40,
  x: 8,
  fill: "#C5D3E0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9F0",
  d: "M57.6,0 L67.2,0 L67.2,10 C67.2,11.1045695 66.3045695,12 65.2,12 L59.6,12 C58.4954305,12 57.6,11.1045695 57.6,10 L57.6,0 L57.6,0 Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 43.426,
  height: 40,
  x: 8,
  fill: "#E3E9F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 20.043,
  height: 12.026,
  x: 20.613,
  y: 10.907,
  fill: "#FFF",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7.349,
  x: 23.286,
  y: 13.579,
  fill: "#C5D3E0",
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7.349,
  x: 30.635,
  y: 13.579,
  fill: "#C5D3E0",
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7.349,
  x: 29.298,
  y: 13.579,
  fill: "#C5D3E0",
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7.349,
  x: 37.316,
  y: 13.579,
  fill: "#C5D3E0",
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.672,
  height: 7.349,
  x: 32.639,
  y: 13.579,
  fill: "#C5D3E0",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.336,
  height: 7.349,
  x: 25.29,
  y: 13.579,
  fill: "#C5D3E0",
  rx: 0.668
}), /*#__PURE__*/React.createElement("rect", {
  width: 14.698,
  height: 5.345,
  x: 23.286,
  y: 28.277,
  fill: "#C5D3E0",
  rx: 2
}));

function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 40,
    viewBox: "0 0 78 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.fc295997.svg";
export { ForwardRef as ReactComponent };